"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'message.send.failed': 'Impossibile inviare il messaggio',
};
